/**
 *
 * @author fuyg
 * @date  2020-06-21
 */

import React, { ReactElement /*, useEffect */ } from 'react'
// import { useSelector, useDispatch, shallowEqual } from 'react-redux'
import styles from './EventCalendarHint.module.scss'
// import { fetchData } from '../sliceName'
// import { RootState } from 'src/pages/home/store/rootReducer'
import { ReactComponent as HintImage } from './hint.svg'

function EventCalendarHint(): ReactElement {
  // 获取数据
  // const dispatch = useDispatch()

  // useEffect(() => {
  // dispatch(fetchData({}))
  // }, [])

  // 绑定数据
  // const { data } = useSelector((state: RootState) => {
  // return {
  // data: state.sliceName.data,
  // }
  // }, shallowEqual)

  return (
    <div className={styles.container}>
      <div>
        <HintImage />
      </div>
      <div className={styles.text}>
        <p>Please select a highlighted date</p>
        <p>from the calendar</p>
      </div>
    </div>
  )
}

export default EventCalendarHint
